import { removeTrapFocus, trapFocus } from '~/global';
import { defineElement } from '~/utils/gw-utils';

class CustomModalDialog extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });

    this.addEventListener('click', (event) => {
      if (
        event.target.nodeName === 'MODAL-DIALOG' ||
        event.target.classList.contains('ModalClose') ||
        event.target.hasAttribute('modal-close')
      ) {
        this.hide();
      }
    });

    this.addEventListener('modal-reinit-focus', this.reiniTrapFocus.bind(this));
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.dispatchEvent(new CustomEvent('modal-open', { bubbles: true }));
    trapFocus(this, this.querySelector('button'));
  }

  reiniTrapFocus(event) {
    const focusElement = event.detail?.focusElement || this.querySelector('button');
    trapFocus(this, focusElement);
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
  }
}
defineElement('custom-modal-dialog', CustomModalDialog);
